import {Link, useLocation, useNavigate, useParams} from "react-router";
import {ArrowLeft} from "lucide-react";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";
import DungeonDetail from "@/dungeons/DungeonDetail.tsx";
import {useDeleteDungeonMutation, useDungeonQuery} from "@/dungeons/DungeonQueries.ts";

export default function DungeonDetailRoute() {
    const {id} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const {campaignPath} = useCampaign();
    const query = useDungeonQuery(id);
    const deleteMutation = useDeleteDungeonMutation();
    if (query.isPending) return <DetailPaneState title="Dungeon wird geladen…" loading/>;
    if (query.isError) return <DetailPaneState title="Dungeon konnte nicht geladen werden" onRetry={() => void query.refetch()}/>;
    if (!query.data) return <DetailPaneState title="Dungeon nicht verfügbar"/>;
    const dungeon = query.data;
    const edit = () => navigate({pathname: campaignPath(`dungeons/${dungeon.id}/edit`), search: location.search});
    const openEditor = () => navigate({pathname: campaignPath(`dungeons/${dungeon.id}/editor`), search: location.search});
    const remove = async () => {
        await deleteMutation.mutateAsync(dungeon.id);
        navigate({pathname: campaignPath("dungeons"), search: location.search}, {replace: true});
    };
    return <main className="min-h-0 grow overflow-auto p-6 md:p-10">
        <div className="mx-auto max-w-5xl space-y-6">
            <Link to={campaignPath("dungeons")} className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
                <ArrowLeft className="size-4"/>Alle Dungeons
            </Link>
            <DungeonDetail key={dungeon.id} dungeon={dungeon} onEdit={edit} onOpenEditor={openEditor} onDelete={remove}/>
        </div>
    </main>;
}
